import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TipologieMezziState } from './tipologie-mezzi.reducer';

export const selectTipologieMezziState =
  createFeatureSelector<TipologieMezziState>('tipologieMezzi');

export const selectTipologieMezzi = createSelector(selectTipologieMezziState, s => s.items);
export const selectLoaded          = createSelector(selectTipologieMezziState, s => s.loaded);
export const selectLoading         = createSelector(selectTipologieMezziState, s => s.loading);
export const selectError           = createSelector(selectTipologieMezziState, s => s.error);
export const selectOpLoading       = createSelector(selectTipologieMezziState, s => s.opLoading);
export const selectOpError         = createSelector(selectTipologieMezziState, s => s.opError);
export const selectCreateSuccessCount = createSelector(selectTipologieMezziState, s => s.createSuccessCount);
export const selectCreateFailureCount = createSelector(selectTipologieMezziState, s => s.createFailureCount);
export const selectLastCreatedId      = createSelector(selectTipologieMezziState, s => s.lastCreatedId);
